import axios from 'axios'

const Welcome = () => import('~/pages/welcome').then(m => m.default || m)

const Evaluations = () => import('~/pages/evaluations').then(m => m.default || m)
const Reports = () => import('~/pages/reports').then(m => m.default || m)

const Login = () => import('~/pages/auth/login').then(m => m.default || m)
const TwoFactor = () => import('~/pages/auth/twofactor').then(m => m.default || m)
const Register = () => import('~/pages/auth/register').then(m => m.default || m)
const PasswordEmail = () => import('~/pages/auth/password/email').then(m => m.default || m)
const PasswordReset = () => import('~/pages/auth/password/reset').then(m => m.default || m)
const NotFound = () => import('~/pages/errors/404').then(m => m.default || m)

const Settings = () => import('~/pages/settings/index').then(m => m.default || m)
const SettingsProfile = () => import('~/pages/settings/profile').then(m => m.default || m)
const SettingsPassword = () => import('~/pages/settings/password').then(m => m.default || m)

const Manage = () => import('~/pages/manage/index').then(m => m.default || m)
const ManageMasks = () => import('~/pages/manage/masks').then(m => m.default || m)
const EditRequirementsProfiles = () => import('~/pages/manage/edit_req_profile').then(m => m.default || m)
const ManageOrganization = () => import('~/pages/manage/organization').then(m => m.default || m)
const ManageDashboard = () => import('~/pages/manage/dashboard').then(m => m.default || m)
const ManageOrganizations = () => import('~/pages/manage/organizations').then(m => m.default || m)
const ManageUsers = () => import('~/pages/manage/users').then(m => m.default || m)

// Method Guard that is called whenever user tries
// to access a specific page (Component used as beforeEnter for the path descriptions)
const TwoFactorsGuard = (to, from, next) => {
  axios.get('api/auth/verify').then(({ data }) => {
    if (data.twoFa === true) {
      next({ name: 'two_factor' })
    } else {
      next()
    }
  }).catch(err => console.log(err))
}

export default [
  { path: '/', name: 'welcome', component: Welcome },

  { path: '/login', name: 'login', component: Login },
  { path: '/2fa', name: 'two_factor', component: TwoFactor },

  { path: '/password/reset', name: 'password.request', component: PasswordEmail, beforeEnter: TwoFactorsGuard
  },
  { path: '/password/reset/:token', name: 'password.reset', component: PasswordReset, beforeEnter: TwoFactorsGuard
  },

  { path: '/users/:id',
    component: Settings,
    beforeEnter: TwoFactorsGuard,
    children: [
      { path: '', name: 'settings', redirect: { name: 'settings.profile' } },
      { path: 'profile', name: 'settings.profile', component: SettingsProfile },
      { path: 'password', name: 'settings.password', component: SettingsPassword }
    ]
  },

  { path: '/users/:id/evaluations', name: 'settings.evaluations', component: Evaluations, beforeEnter: TwoFactorsGuard
  },

  { path: '/manage',
    component: Manage,
    beforeEnter: TwoFactorsGuard,
    name: 'manage',
    children: [
      { path: 'organization', name: 'manage.organization', component: ManageOrganization },
      { path: 'dashboard', name: 'manage.dashboard', component: ManageDashboard },
      { path: 'organizations', name: 'manage.organizations', component: ManageOrganizations },
      { path: 'users', name: 'manage.users', component: ManageUsers },
      { path: 'recipients', name: 'manage.recipients', component: ManageUsers },
      { path: 'masks', name: 'manage.masks', component: ManageMasks }
    ]
  },
  { path: '/manage/requirements/:id/edit', name: 'manage.requirements.edit', component: EditRequirementsProfiles, beforeEnter: TwoFactorsGuard },

  { path: '*', component: NotFound }
]



// WEBPACK FOOTER //
// ./resources/js/router/routes.js